import './AccountDropDown.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import PenNameList from 'components/nav/shared/PenNameList';
import AuthorName from 'utils/AuthorName';
import { Dropdown } from 'semantic-ui-react';

const AccountDropDown = ({ identities }, { getString }) => {
  const showPenNameSwitcher = identities && identities.length > 1;
  return (
    <Dropdown
      pointing="top right"
      icon={null}
      trigger={(
        <span className="aa-nav-link">
          {AuthorName.localizedAuthorName()}
          <span className="caret" />
        </span>
      )}
      className="account-dropdown"
    >
      <Dropdown.Menu>
        {showPenNameSwitcher ? (
          <React.Fragment>
            <div className="semantic-dropdown-header">{getString('AA_Switch_Pen_Name')}</div>
            <PenNameList identities={identities} isMobile={false} />
            <Dropdown.Divider />
          </React.Fragment>
        ) : null}
        <Dropdown.Item text={getString('AA_Preferences')} as={Link} to="/account/preferences" tabIndex="0" />
        <Dropdown.Item text={getString('AA_SignOut')} href="/signout" />
      </Dropdown.Menu>
    </Dropdown>
  );
};

AccountDropDown.propTypes = {
  identities: PropTypes.arrayOf(PropTypes.object).isRequired,
};

AccountDropDown.contextTypes = {
  getString: PropTypes.func.isRequired,
};

export default AccountDropDown;
